module.exports = __webpack_public_path__ + "static/media/logo-new-dark.fb0d02cd.png";